import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';

// DOCS: Import all the functions here
import {
  UI_updateCompleteProfileRouteReducer,
  UI_updateConvUIStepsStatusReducer,
  UI_updateHorizantalProgressReducer,
  UI_updateInJourneyQuitFlagReducer,
  UI_updateShowLogoutModalFlagReducer,
  UI_updateShowSessionExpiredModalReducer,
  UI_updateSideDrawerOpenReducer,
  UI_updateOnlyCrossIconReducer,
  UI_updatePostPanAckScreenReducer,
} from './functions';

import intialStateUIControls from './intial-state-ui-controls';

export const uiControlsSlice = createSlice({
  name: 'uiControls',
  initialState: intialStateUIControls,
  reducers: {
    ...UI_updateHorizantalProgressReducer,
    ...UI_updateConvUIStepsStatusReducer,
    ...UI_updateCompleteProfileRouteReducer,
    ...UI_updateInJourneyQuitFlagReducer,
    ...UI_updateShowLogoutModalFlagReducer,
    ...UI_updateShowSessionExpiredModalReducer,
    ...UI_updateSideDrawerOpenReducer,
    ...UI_updateOnlyCrossIconReducer,
    ...UI_updatePostPanAckScreenReducer,
  },
  extraReducers: {},
});

// DOCS: Dispacth actions destructuring here
const {
  UI_updateHorizantalProgress,
  UI_updateConvUIStepsStatus,
  UI_updateCompleteProfileRoute,
  UI_updateInJourneyQuitFlag,
  UI_updateShowLogoutModalFlag,
  UI_updateShowSessionExpiredModal,
  UI_updateSideDrawerOpen,
  UI_updateOnlyCrossIcon,
  UI_updatePostPanAckScreen,
} = uiControlsSlice.actions;

export function useUIControlsStore() {
  const showHorizontalProgressBar = useSelector(
    (state) => state.uiControls.showHorizontalProgressBar
  );
  const horizontalProgressBarProgress = useSelector(
    (state) => state.uiControls.horizontalProgressBarProgress
  );
  const convUiStepsDetails = useSelector(
    (state) => state.uiControls.convUiStepsDetails
  );
  const completeProfileRoute = useSelector(
    (state) => state.uiControls.completeProfileRoute
  );
  const inJourneyQuitModalOpen = useSelector(
    (state) => state.uiControls.inJourneyQuitModalOpen
  );
  const showLogoutPopupModal = useSelector(
    (state) => state.uiControls.showLogoutPopupModal
  );
  const showSessionExpiredModal = useSelector(
    (state) => state.uiControls.showSessionExpiredModal
  );
  const isSideDrawerOpen = useSelector(
    (state) => state.uiControls.isSideDrawerOpen
  );
  const onlyCrossIcon = useSelector((state) => state.uiControls.onlyCrossIcon);
  const postpanackscreen = useSelector(
    (state) => state.uiControls.postpanackscreen
  );

  const dispatch = useDispatch();
  return {
    // DOCS: State returns here
    showHorizontalProgressBar,
    horizontalProgressBarProgress,
    convUiStepsDetails,
    completeProfileRoute,
    inJourneyQuitModalOpen,
    showLogoutPopupModal,
    showSessionExpiredModal,
    isSideDrawerOpen,
    onlyCrossIcon,
    postpanackscreen,

    // DOCS: Write sync methods here
    updateHorizantalProgress: (payload) =>
      dispatch(UI_updateHorizantalProgress(payload)),
    updateConvUIStepsStatus: (payload) =>
      dispatch(UI_updateConvUIStepsStatus(payload)),
    updateCompleteProfileRoute: (payload) =>
      dispatch(UI_updateCompleteProfileRoute(payload)),
    updateInJourneyQuitFlag: (payload) =>
      dispatch(UI_updateInJourneyQuitFlag(payload)),
    updateShowLogoutModalFlag: (payload) =>
      dispatch(UI_updateShowLogoutModalFlag(payload)),
    updateShowSessionExpiredModal: (payload) =>
      dispatch(UI_updateShowSessionExpiredModal(payload)),
    updateSideDrawerOpen: (payload) =>
      dispatch(UI_updateSideDrawerOpen(payload)),
    updateOnlyCrossIcon: (payload) => dispatch(UI_updateOnlyCrossIcon(payload)),
    updatePostPanAckScreen: (payload) =>
      dispatch(UI_updatePostPanAckScreen(payload)),
  };
}

export default uiControlsSlice.reducer;
